import styled from 'styled-components';

export const TargetContainer = styled.div`
  & > .hefesto-icon svg {
    width: 6.25rem;
    height: 6.25rem;
  }
  & .graph-skeleton {
    margin: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  & > .monthly-goal {
    width: 65%;
    min-width: 19.5rem;
    float: left;
    margin-top: 1rem;
    margin-left: 1rem;
    & > .target-title {
      width: 70%;
      float: left;
      margin-bottom: 0.2rem;
      margin-top: 0.45rem;
    }
    & > .month-selector {
      width: 30%;
      float: right;
    }
    & > .line {
      clear: both;
      width: 100%;
    }
    & > .graph-label {
      line-height: var(--line-height-size-xxl);
      font-size: var(--font-size-md);
      & > .label-left {
        width: 50%;
        float: left;
        text-align: left;
      }
      & > .label-right {
        width: 50%;
        float: right;
        text-align: right;
      }
    }
    & .simple-graph {
      & .hefesto-simple-graph__bar-wrapper {
        width: 100%;
        height: 1.5rem;
      }
      & .hefesto-simple-graph__bar {
        height: 1.5rem;
      }
      & .hefesto-simple-graph--danger {
        & .hefesto-simple-graph__bar {
          background-color: var(--support-color-02-800);
        }
      }
      & .hefesto-simple-graph--warning {
        & .hefesto-simple-graph__bar {
          background-color: var(--support-color-05-700);
        }
      }
      & .hefesto-simple-graph--success {
        & .hefesto-simple-graph__bar {
          background-color: var(--support-color-05-700);
        }
      }
      & .hefesto-simple-graph {
        margin-top: 2rem;
        & > .hefesto-simple-graph__value {
          font-size: var(--font-size-xl);
          font-weight: 600;
          line-height: var(--line-height-size-xxxl);
        }
      }
    }
  }
`;
